/* eslint-disable no-restricted-imports */
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { Box, Grid, SxProps } from '@mui/material';
import { useWindowSize } from 'integration/hooks/useWindowSize';
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { DpH2 } from '../DPText';

type Props = {
	children: JSX.Element[];
	framesx?: SxProps;
	title?: string;
};

const baseSettings = {
	className: 'center',
	centerMode: true,
	dots: false,
	infinite: true,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 4000,
	arrows: false,
};

export const DpMarksSliderTemp: React.FC<Props> = ({ children, framesx, title }) => {
	const isMobile = useIsMobile();
	const [width] = useWindowSize();
	const itemWidth = isMobile ? 92 : 134;
	const itemSpacing = isMobile ? 50 : 30;

	const slidesToShow = Math.floor((width + itemSpacing) / (itemWidth + itemSpacing));

	const settings = {
		...baseSettings,
		slidesToShow,
	};

	const cleanChildren = React.Children.toArray(children).filter((child) =>
		React.isValidElement(child)
	);

	return (
		<Box
			width="100vw"
			minWidth="100%"
			maxWidth="100%"
			marginBottom={{ xs: 'var(--spacing-8)', sm: 'var(--spacing-13)' }}
			padding={'var(--spacing-8) 0px 0px 0px'}
			sx={framesx}
		>
			{title ? <DpH2 sx={{ textAlign: 'center', marginBottom: '22px' }}>{title}</DpH2> : null}
			<Slider {...settings}>
				{
					[...cleanChildren, ...cleanChildren, ...cleanChildren, ...cleanChildren].map(
						(mark, index: number) => <Grid key={index}>{mark}</Grid>
					) as any
				}
			</Slider>
		</Box>
	);
};
